<template>
    <div>
        <template v-if="data.step == 'confirm'">
            <a-modal centered :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
                <!-- header -->
                <div class="custom-modal-header">
                    <label class="custom-modal-header-title">
                        {{ $t('รับสิทธิ์') }}
                    </label>
                </div>
                <div class="custom-modal-body" v-if="data.label">
                    <span style="display: block">
                        {{ data && data.choice ? data.choice.label_top : '' }}
                    </span>
                    <span style="display: block">
                        {{ data && data.choice ? data.choice.label : '' }}
                    </span>
                </div>
                <div class="custom-modal-body">
                    <div class="custom-modal-body-detail-2">
                        <span style="display: block">
                            รหัสรับสิทธิ์ มีอายุ
                            {{ data && data.choice && data.choice.count_time ? Number(data.choice.count_time / 60) : '' }}
                            นาที หลังกด
                        </span>
                        <span style="display: block"> ปุ่ม "ยืนยัน" กรุณากดรับสิทธิ์ต่อ </span>
                        <span style="display: block"> หน้าเจ้าหน้าที่ และศึกษาเงื่อนไขก่อน </span>
                        <span style="display: block"> การใช้บริการ </span>
                    </div>
                </div>
                <!-- footer -->
                <div class="custom-modal-footer">
                    <a-button key="back" size="large" class="custom-modal-footer-single-cancel-btn mr-4" @click="cancel()">
                        {{ $t('ยกเลิก') }}
                    </a-button>
                    <a-button key="back" size="large" class="custom-modal-footer-single-confirm-btn ml-4" @click="create()">
                        {{ $t('ยืนยัน') }}
                    </a-button>
                </div>
            </a-modal>
        </template>
        <template v-else-if="data.step == 'back'">
            <a-modal centered :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
                <div class="custom-modal-header">
                    <label class="custom-modal-header-title">
                        {{ data.title }}
                    </label>
                </div>
                <div class="custom-modal-body">
                    <label class="custom-modal-body-detail" v-html="data.message"> </label>
                </div>
                <div class="custom-modal-footer">
                    <a-button key="back" size="large" class="custom-modal-footer-single-cancel-btn mr-4" @click="cancel()">
                        {{ $t('ยกเลิก') }}
                    </a-button>
                    <a-button key="back" size="large" class="custom-modal-footer-single-confirm-btn ml-4" @click="confirm()">
                        {{ $t('ยืนยัน') }}
                    </a-button>
                </div>
            </a-modal>
        </template>
        <template v-else-if="data.step == 'error'">
            <a-modal centered :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
                <div class="custom-modal-body">
                    <label class="custom-modal-body-detail" v-html="data.message"> </label>
                </div>
                <!-- footer -->
                <div class="custom-modal-footer">
                    <a-button key="back" class="custom-modal-footer-single-close-btn" style="width: 100% !important" @click="onCloseError()">
                        {{ $t('ปิดหน้าต่าง') }}
                    </a-button>
                </div>
            </a-modal>
        </template>
        <template v-else>
            <a-modal centered :bodyStyle="{ padding: 0 }" :visible="visible" :closable="false" :footer="null">
                <div class="custom-modal-body">
                    <label class="custom-modal-body-detail" v-html="data.message"> </label>
                </div>
                <!-- footer -->
                <div class="custom-modal-footer">
                    <a-button key="back" class="custom-modal-footer-single-close-btn" style="width: 100% !important" @click="cancel()">
                        {{ $t('ปิดหน้าต่าง') }}
                    </a-button>
                </div>
            </a-modal>
        </template>
    </div>
</template>
<script>
export default {
    props: ['visible', 'data'],
    beforeCreate() {
        this.form = this.$form.createForm(this, { name: 'form_in_modal' });
    },
    data() {
        return {};
    },
    mounted() {
        console.log('visible s', this.visible);
        console.log('data', this.data);
    },
    methods: {
        cancel() {
            this.$emit('on-cancel');
        },
        create() {
            this.$emit('on-save');
        },
        confirm() {
            this.$emit('on-confirm');
        },
        onCloseError() {
            this.$router.push({
                path: '/privilege',
            });
        },
    },
};
</script>
<style scoped>
.custom-modal-header {
    background: transparent;
    padding: 8px 12px;
    padding-bottom: 0;
    text-align: center;
    border-radius: 10px 10px 0 0;
}
.custom-modal-header-title {
    color: #ffffff !important;
    font-size: 23px;
    font-weight: 600;
}
.custom-modal-body {
    color: #ff7105 !important;
    background: transparent;
    padding: 16px 10px;
    padding-bottom: 0;
    text-align: center;
}
.custom-modal-body-detail {
    color: #000 !important;
    font-size: 14px;
    font-weight: 300;
}
.custom-modal-body-detail-2 {
    color: #141322 !important;
    font-size: 14px;
    font-weight: 300;
}
.custom-modal-footer {
    background: transparent;
    padding: 16px 10px;
    text-align: center;
}
.custom-modal-footer-single-confirm-btn {
    background: #cc0000 !important;
    color: #fff !important;
    width: 40% !important;
    border-radius: 20px !important;
    font-size: 18px !important;
}
.custom-modal-footer-single-cancel-btn {
    background: #fff !important;
    border-color: #cc0000 !important;
    color: #cc0000 !important;
    width: 40% !important;
    border-radius: 20px !important;
    font-size: 18px !important;
}
.custom-modal-footer-single-close-btn {
    background: linear-gradient(0deg, #ff7105, #ff9500 100%) no-repeat;
    color: #fff;
    width: 100%;
}
</style>
